<script lang="ts">
  import type { Snippet } from "svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"

  type Props = {
    label?: string
    tag?: string
    tagTooltipContent?: string
    selectedCount?: number
    targetCount?: number
    pending?: boolean
    disabled?: boolean
    emptyLabel?: string
    pendingLabel?: string
    children?: Snippet | null
    onApply: () => void | Promise<void>
  }

  let {
    label = "Vorkonfiguration",
    tag = "",
    tagTooltipContent = "",
    selectedCount = 0,
    targetCount = 0,
    pending = false,
    disabled = false,
    emptyLabel = "Keine passenden Zeilen",
    pendingLabel = "Wird angewendet...",
    children = null,
    onApply,
  }: Props = $props()

  const applyLabel = $derived(
    pending
      ? pendingLabel
      : selectedCount > 0
        ? `Auf ausgewählte anwenden (${targetCount})`
        : `Auf alle anwenden (${targetCount})`,
  )
  const effectiveDisabled = $derived(disabled || pending || targetCount <= 0)
  const disabledTooltip = $derived(targetCount <= 0 ? emptyLabel : "")
</script>

{#snippet applyButtonSnippet()}
  <CTA
    type="tertiaryButton"
    content={applyLabel}
    darkMode={false}
    disabled={effectiveDisabled}
    tooltipContent={disabledTooltip}
    onClick={() => void onApply()}
  />
{/snippet}

<ActionBox {label} {tag} {tagTooltipContent} darkMode={false} buttonSnippet={applyButtonSnippet}>
  <div class="inbox-workflow-preconfiguration-box">
    {@render children?.()}
  </div>
</ActionBox>

<style>
  .inbox-workflow-preconfiguration-box {
    color: var(--text-100);
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }

  .inbox-workflow-preconfiguration-box :global(p) {
    color: color-mix(in srgb, var(--text-100) 72%, transparent);
    margin: 0;
  }
</style>
